<template>
  <div class="px-2 overflow-y-auto pt-4 h-full pb-14 font-medium">
    <Profile />
    <!-- SECTION 1 -->
    <!-- SECTION 2 -->
    <p class="text-lg font-bold text-left mt-6">App</p>
    <div class="bg-white rounded-sm p-2 shadow-md border border-white">
      <div v-if="false" class="flex py-4">
        <img alt="image" class="h-6 mr-2" src="@/assets/icons/globe.svg" />
        <p class="flex-1 text-left">Language</p>
        <select
          class="border border-white rounded-sm px-1 outline-none"
          :onchange="
            xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxchangeLanguage
          "
          disabled
          name="languages"
          id="languages"
        >
          <option selected value="ar">Soon</option>
          <!-- <option value="ar">Arabic</option>
          <option value="de">German</option>
          <option value="en">English</option>
          <option value="es">Spanish</option>
          <option value="ha">Hausa</option>
          <option value="ig">Igbo</option>
          <option value="it">Italian</option>
          <option value="ja">Japanese</option>
          <option value="ko">Korean</option>
          <option value="pt">Portuguese</option>
          <option value="ru">Russian</option>
          <option value="tl">Tagalog</option>
          <option value="yo">Yoruba</option>
          <option value="zh">Chinese</option> -->
        </select>
      </div>
      <!-- location -->
      <div v-if="false" class="flex py-4">
        <img alt="image" class="h-6 mr-2" src="@/assets/icons/location.svg" />
        <p class="flex-1 text-left">Location Tracking</p>
        <select
          disabled
          class="border border-white px-1"
          id="locationTrackingToggle"
          :onchange="toggleLocationTracking"
        >
          <option selected :value="true">Soon</option>
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </select>
      </div>
      <!-- notifications -->
      <div v-if="false" class="flex py-4">
        <img alt="image" class="h-6 mr-2" src="@/assets/icons/bell.svg" />
        <p class="flex-1 text-left">Notifications</p>
        <select
          class="border border-white px-1"
          :onchange="toggleNotifications"
          id="notificationsToggle"
          :value="true"
        >
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </select>
      </div>
      <MoreItem
        v-for="item in App"
        :key="item"
        :title="item.title"
        :icon="item.icon"
        :pathName="item.pathName"
      />
    </div>
    <!-- SECTION 3 -->
    <p class="text-lg font-bold text-left mt-4">More</p>
    <div class="bg-white rounded-sm p-2 shadow-md border border-white">
      <MoreItem
        v-for="item in More"
        :key="item"
        :title="item.title"
        :icon="item.icon"
        :pathName="item.pathName"
      />
    </div>
    <br>
    <button
      @click="deleteAccount"
      class="
        flex-1
        text-red-600
        bg-gradient-to-r
        from-gray-100
        rounded-l-lg
        flex
        tracking-tight
        font-semibold
        items-center
        justify-center
      "
    >
      Delete Account
    </button>
  </div>
</template>

<script>
import Profile from "@/views/more/profile/Profile.vue";
import MoreItem from "@/views/more/MoreItem.vue";
import { Browser } from "@capacitor/browser";

export default {
  components: { Profile, MoreItem },
  data() {
    return {
      App: [
        // {
        //   title: "Loyalty",
        //   icon: require("@/assets/icons/loyalty.svg"),
        //   pathName: "Loyalty",
        // },
        {
          title: "Favourites",
          icon: require("@/assets/icons/heartblack.svg"),
          pathName: "Favourites",
        },
        {
          title: "Feedback",
          icon: require("@/assets/icons/feedback.svg"),
          pathName: "Feedback",
        },
        {
          title: "Share Our App",
          icon: require("@/assets/icons/shareappmore.svg"),
          pathName: "ShareApp",
        },
      ],
      More: [
        {
          title: "About Us",
          icon: require("@/assets/logograysquare.png"),
          pathName: "AboutUs",
        },
        {
          title: "Frequently Asked Questions",
          icon: require("@/assets/icons/question.svg"),
          pathName: "FAQ",
        },
        // {
        //   title: "How To Install",
        //   icon: require("@/assets/icons/install.svg"),
        //   pathName: "HowToInstall",
        // },
        {
          title: "Privacy Policy",
          icon: require("@/assets/icons/privacy.svg"),
          pathName: "PrivacyPolicy",
        },
        {
          title: "Terms of Service",
          icon: require("@/assets/icons/terms.svg"),
          pathName: "TermsOfService",
        },
      ],
    };
  },
  computed: {
    defaultLanguage() {
      return localStorage.defaultLanguage;
    },
  },
  methods: {
    deleteAccount() {
      var url = this.$store.state.appDetails?.update?.deleteAccountLink;
      Browser.open({ url, toolbarColor: "#af803e" });
    },
    changeLanguage() {
      localStorage.defaultLanguage = document.getElementById("languages").value;
      location.reload();
    },
    toggleLocationTracking() {
      localStorage.locationTracking = document.getElementById(
        "locationTrackingToggle"
      ).value;
    },
    toggleNotifications() {
      localStorage.notifications = document.getElementById(
        "notificationsToggle"
      ).value;
    },
  },
};
</script>
